import React from "react";

// ─────────────────────────────────────────────
// Inject animations once
// ─────────────────────────────────────────────
if (
  typeof document !== "undefined" &&
  !document.getElementById("__confirm_modal_styles")
) {

  const style = document.createElement("style");

  style.id = "__confirm_modal_styles";

  style.innerHTML = `

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }

    @keyframes modalFade {
      from {
        opacity: 0;
        transform: translateY(20px) scale(0.96);
      }

      to {
        opacity: 1;
        transform: translateY(0px) scale(1);
      }
    }

  `;

  document.head.appendChild(style);
}

export default function ConfirmModal({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  confirmLoading,
}) {

  if (!open) return null;

  return (
    <div style={styles.overlay}>

      <div style={styles.modal}>

        {/* Icon */}
        <div style={styles.iconWrapper}>
          ✓
        </div>

        {/* Title */}
        <h2 style={styles.title}>
          {title}
        </h2>

        {/* Message */}
        <p style={styles.message}>
          {message}
        </p>

        {/* Buttons */}
        <div style={styles.actions}>

          <button
            style={styles.cancel}
            onClick={onCancel}
          >
            Cancel
          </button>

          <button
            style={{
              ...styles.confirm,
              opacity: confirmLoading ? 0.7 : 1,
              cursor: confirmLoading
                ? "not-allowed"
                : "pointer",
            }}
            onClick={onConfirm}
            disabled={confirmLoading}
          >
            {confirmLoading ? (
              <div style={styles.spinner}></div>
            ) : (
              confirmText
            )}
          </button>

        </div>
      </div>
    </div>
  );
}

const styles = {

  // ─────────────────────────────────────────────
  // Overlay
  // ─────────────────────────────────────────────
  overlay: {
    position: "fixed",
    inset: 0,
    width: "100%",
    height: "100%",
    background: "rgba(15,23,42,0.55)",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    padding: "20px",
    boxSizing: "border-box",

    zIndex: 9999,
  },

  // ─────────────────────────────────────────────
  // Modal
  // ─────────────────────────────────────────────
  modal: {
    width: "100%",
    maxWidth: "420px",

    background: "rgba(255,255,255,0.96)",

    borderRadius: "28px",

    padding: "32px 24px",

    boxSizing: "border-box",

    border: "1px solid rgba(255,255,255,0.7)",

    boxShadow:
      "0 24px 70px rgba(0,0,0,0.18)",

    textAlign: "center",

    animation:
      "modalFade 0.25s ease",
  },

  // ─────────────────────────────────────────────
  // Top Icon
  // ─────────────────────────────────────────────
  iconWrapper: {
    width: "74px",
    height: "74px",

    borderRadius: "50%",

    margin: "0 auto 20px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    background:
      "linear-gradient(135deg,#2563eb,#1d4ed8)",

    color: "#fff",

    fontSize: "34px",
    fontWeight: "800",

    boxShadow:
      "0 14px 35px rgba(37,99,235,0.35)",
  },

  // ─────────────────────────────────────────────
  // Title
  // ─────────────────────────────────────────────
  title: {
    margin: 0,

    fontSize: "24px",

    fontWeight: "800",

    color: "#111827",

    lineHeight: "32px",
  },

  // ─────────────────────────────────────────────
  // Message
  // ─────────────────────────────────────────────
  message: {
    marginTop: "14px",

    color: "#6b7280",

    fontSize: "15px",

    lineHeight: "24px",

    wordBreak: "break-word",
  },

  // ─────────────────────────────────────────────
  // Buttons wrapper
  // ─────────────────────────────────────────────
  actions: {
    marginTop: "30px",

    display: "flex",

    gap: "12px",

    flexWrap: "wrap",
  },

  // ─────────────────────────────────────────────
  // Cancel Button
  // ─────────────────────────────────────────────
  cancel: {
    flex: 1,

    minWidth: "120px",

    padding: "14px 18px",

    borderRadius: "14px",

    border: "none",

    background: "#f3f4f6",

    color: "#111827",

    fontWeight: "700",

    fontSize: "14px",

    cursor: "pointer",

    transition: "0.2s ease",
  },

  // ─────────────────────────────────────────────
  // Confirm Button
  // ─────────────────────────────────────────────
  confirm: {
    flex: 1,

    minWidth: "120px",

    padding: "14px 18px",

    borderRadius: "14px",

    border: "none",

    background:
      "linear-gradient(135deg,#2563eb,#1d4ed8)",

    color: "#fff",

    fontWeight: "700",

    fontSize: "14px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    minHeight: "50px",

    boxShadow:
      "0 10px 25px rgba(37,99,235,0.25)",
  },

  // ─────────────────────────────────────────────
  // Spinner
  // ─────────────────────────────────────────────
  spinner: {
    width: "18px",
    height: "18px",

    border:
      "2px solid rgba(255,255,255,0.4)",

    borderTop:
      "2px solid #ffffff",

    borderRadius: "50%",

    animation:
      "spin 0.6s linear infinite",
  },
};